import { render, staticRenderFns } from "./families-table.vue?vue&type=template&id=10e20472"
import script from "./families-table.vue?vue&type=script&lang=js"
export * from "./families-table.vue?vue&type=script&lang=js"
import style0 from "./families-table.vue?vue&type=style&index=0&id=10e20472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports